// extracted by mini-css-extract-plugin
export default {"title":"SupportList_title__I2+mF","category_name":"SupportList_category_name__2ajLu","center_align":"SupportList_center_align__AalB0","no_result":"SupportList_no_result__ZvGYj"};